import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { useNavigate } from 'react-router-dom';
import { env } from 'env';
import Cookies from 'js-cookie';

export const SaveElectronicForm = async (
  listDetail,
  additionals,
  reset,
  fieldArrayName,
  StateBank,
  isSurveyPath
) => {
  const user = isSurveyPath
    ? JSON.parse(Cookies.get('user'))
    : JSON.parse(sessionStorage.getItem('patient'));

  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_ELS_FORM_SAVE_PATIENT}`,
    true,
    {
      idElsFormPatient: additionals.idElsFormPatient,
      formID: additionals.formID,
      patientFormID:
        additionals.idElsFormPatient !== 0 ? 1 : 0,
      idPatient: user.IdPatient,
      idConfer: user.Id || user.FldId,
      AlloEdit: true,
      idType: 27,
      idCartablPatient: additionals.idCartablPatient,
      idPerson: user.IdPerson || user.FldIdDoctor,
      listDetail: listDetail,
    }
  ).then((response) => {
    if (response.data.resCode === 1) {
      SwalAlert(
        'success',
        response.data.resMessage,
        false
      ).then(() => {
        if (
          additionals.idElsFormPatient !== 0 &&
          additionals.navigate
        ) {
          additionals.navigate(-1);
        }
      });
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }

    if (
      additionals.idElsFormPatient === 0 &&
      !additionals.navigate
    ) {
      StateBank?.setForceRender((prev) => !prev);
      StateBank?.setStateRecoil((prev) => !prev);
      StateBank?.setTitle('');
      reset();
    }
  });
};
